<template>

    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-row>
      <el-col :span="8">
      <el-form-item label="项目编号" prop="projectCode">
        <el-input maxlength="30"  v-model="ruleForm.projectCode"></el-input>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="ruleForm.projectName"></el-input>
      </el-form-item>
        <el-form-item label="管理员账号" prop="userAccount">
          <el-input v-model="ruleForm.userAccount"></el-input>
        </el-form-item>
        <el-form-item label="管理员密码" prop="userPassword">
          <el-input v-model="ruleForm.userPassword"></el-input>
        </el-form-item>
        <el-form-item label="配置变量1" prop="variable1">
          <el-input v-model="ruleForm.variable1"></el-input>
        </el-form-item>
        <el-form-item label="配置变量2" prop="variable2">
          <el-input v-model="ruleForm.variable2"></el-input>
        </el-form-item>
        <el-form-item label="配置变量3" prop="variable3">
          <el-input v-model="ruleForm.variable3"></el-input>
        </el-form-item>
        <el-form-item label="配置变量4" prop="variable4">
          <el-input v-model="ruleForm.variable4"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 100%"@click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-col>
      </el-row>


    </el-form>

</template>

<script>
   import{initializeData} from '@/api/system/initdata';
  export default {
    data() {
      return {
       ruleForm: {
       variable1:'',
       variable2:'',
       variable3:'',
       variable4:'',
       userPassword:'',
       userAccount:'',
       projectCode:'',
       projectName:''
        },
        rules: {
      projectName: [
            { required: true, message: '请输入项目名称', trigger: 'blur' },
            { max: 30, message: '最多输入30字符!', trigger: 'blur' }
          ],
        projectCode: [
          { required: true, message: '请输入项目编号', trigger: 'blur' },
          { max: 30, message: '最多输入30字符!', trigger: 'blur' }
          ],
        userAccount: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' },
          { max: 30, message: '最多输入30字符!', trigger: 'blur' }
          ],
        userPassword: [
          { required: true, message: '请输入管理员密码', trigger: 'blur' },
          { max: 30, message: '最多输入30字符!', trigger: 'blur' }
          ],
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
            });
            initializeData(this.ruleForm).then((date) => {
              console.log(date);
              if(date.data.success){
                this.$message.success('初始化成功!');
              }else {
                this.$message.error('初始化失败!');
              }
              loading.close();
            }, error => {
              console.log(error);
              loading.close();
            });
          } else {
            //this.$message.error('初始化失败!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

